import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {ImportUtil} from '../../utils/importUtil.js';
import {attachWorkspaceFilterState} from '../../utils/workspaceStateUtil.js';
import {BaseComponent} from '../basecomponent.js';

/* global customElements */
class UnitGroupGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		var unitGroupGrid = this;
		setTimeout(function(){
			unitGroupGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var unitGroupGrid = this;
		
		var toolbarFilter = ElementUtil.create({
			tag: 'dl-toolbar',
		'collapse-label': 'Filter',
			slot: 'toolbar',
			theme: 'spacing',			
			children: [				
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterType',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Filter By',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,
					value: 'groupName',
					postinit: function(combo) {						
						var lookups = [							
							{
								code: 'groupName',
								description: 'Group Name'								
							},
							{
								code: 'groupCode',
								description: 'Code'	
							},
							{
								code: 'description',
								description: 'Description'	
							}
						];
						combo.items = lookups;						
					},
					placeHolder: 'Select'					
				},				
				{
					tag: 'vaadin-text-field',
					itemid: 'filterValue',
					'class': 'spacer-toolbar-item',
					'keep-open': true,
					label: 'Filter Value',
					listeners: {
						input: {
							fn: function() {
								actionRefresh();
							},
							buffer: 2000
					    }
					}
				},
				{	
					tag: 'vaadin-combo-box',
					itemid: 'status',						
					'class': 'spacer-toolbar-item',
					'item-value-path': 'code',
					'item-label-path': 'desc',
					'prevent-invalid-input': true,
					postinit: function(combo) {							
						combo.items = [
							{
								code: 'A',
								desc: 'Active'
							}, {
								code: 'I',
								desc: 'Inactive'
							}
						];
						combo.value = 'A';
					},
					listeners: {
						'selected-item-changed': function(event) {
							if (actionRefresh){
								actionRefresh();
							}
						}
					}					
				}				
			]
		});		
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',					
					permissions: ['UNITGROUP_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')						
					],
					listeners: {
						click: function() {
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['UNITGROUP_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')						
					],
					listeners: {
						click: function() {
							actionAddEdit(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'manageUnits',
					theme: 'contrast',
					'class': 'spacer-toolbar-item',
					disabled: true,
					permissions: ['UNITGROUP_MANAGEMENT:WRITE'],
					children: [
						ElementUtil.makeIcon('vaadin:truck', ' Manage Units')
					],
					listeners: {
						click: function () {
							actionManageUnits(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'history',
					theme: 'contrast',
					'class': 'spacer-toolbar-item',
					disabled: true,
					permissions: ['UNITGROUP_MANAGEMENT:READ'],
					children: [
						ElementUtil.makeIcon('vaadin:clock', ' History')
					],
					listeners: {
						click: function () {
							actionHistory(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'unitsInGroup',
					theme: 'contrast',
					'class': 'spacer-toolbar-item',
					disabled: true,
					permissions: ['UNITGROUP_MANAGEMENT:READ'],
					children: [
						ElementUtil.makeIcon('vaadin:arrow-circle-right-o', ' Units In Group')
					],
					listeners: {
						click: function () {
							actionResolveUnits(grid.selectedItems[0]);
						}
					}
				},	
				{
					tag: 'div',
					style: 'float: right;',
					children:[
						{
							tag: 'dl-action-button',
							itemid: 'tools',
							'class': 'spacer-toolbar-item',
							children: [
								ElementUtil.makeIcon('vaadin:wrench', ' Tools')
							],
							properties: {
								menu: [
									{
										tag: 'dl-action-menu-item',
										itemId: 'toggleStatus',
										disabled: true,
										permissions: ['UNITGROUP_MANAGEMENT:UPDATE_STATUS'],
										trustedInnerHTML: true,
										innerHTML: '<vaadin-icon icon="vaadin:check"></vaadin-icon> Toggle Status',
										listeners: {
											click: function () {
												if (grid.selectedItems[0]) {
													actionUpdateStatus(grid.selectedItems[0]);
												}
											}
										}
									},
									{
										tag: 'hr'
									},
									{
										tag: 'dl-action-menu-item',
										itemId: 'import',
										permissions: ['UNITGROUP_MANAGEMENT:WRITE'],
										trustedInnerHTML: true,
										innerHTML: '<vaadin-icon icon="vaadin:download"></vaadin-icon> Import',
										listeners: {
											click: function () {
												actionImportGroups();
											}
										}
									},
									{
										tag: 'dl-action-menu-item',
										itemId: 'importAssignments',
										permissions: ['UNITGROUP_MANAGEMENT:WRITE'],
										trustedInnerHTML: true,
										innerHTML: '<vaadin-icon icon="vaadin:download"></vaadin-icon> Import Assignments',
										listeners: {
											click: function () {
												actionImportAssignments();
											}
										}
									}
								]
							}
						},
						{
							tag: 'span',
							innerHTML: '|'
						},
						{
							tag: 'dl-action-button',
							itemid: 'delete',
							theme: 'error primary',
							'class': 'spacer-toolbar-item',
							disabled: true,
							permissions: ['UNITGROUP_MANAGEMENT:DELETE'],
							children:[
								ElementUtil.makeIcon('vaadin:trash', 'Remove')
							],
							listeners: {
								click: function() {
									actionDelete(grid.selectedItems[0]);
								}
							}
						}
					]
				}
			]
		});		
		
		var toolbarContainer = ElementUtil.create({
			tag: 'div',
			slot: 'toolbar',
			children: [
				toolbarFilter,
				ElementUtil.create({
					tag: 'hr'
				}),
				toolbar
			]
		});			
	
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'wrap-cell-content row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [								
				{						
					path: 'groupName',
					header: 'Name',
					width: '7em'
				},	
				{						
					path: 'groupCode',
					header: 'Code',
					width: '7em'
				},
				{						
					path: 'description',
					header: 'Description',
					width: '7em'
				},
				{						
					path: 'contactName',
					header: 'Contact Name',
					width: '8em'
				},
				{						
					path: 'email',
					header: 'Email',
					width: '10em'
				},
				{						
					path: 'unassignedUnitGroup',
					header: 'Unassigned',
					width: '6em',
					renderer: function(root, column, rowData) {
						root.textContent = rowData.item.unassignedUnitGroup === true ? 'Yes' : '';
					}
				},
				{						
					path: 'activeStatus',
					header: 'Active Status',
					width: '7em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {
						var selectedGroup = grid.selectedItems[0];
						var isUnassignedGroup = selectedGroup.unassignedUnitGroup === true;
						ElementUtil.query(toolbar, 'edit').disabled = false;
						ElementUtil.query(toolbar, 'delete').disabled = false;
						ElementUtil.enableDisableAction(toolbar, 'toggleStatus', false);
						ElementUtil.query(toolbar, 'manageUnits').disabled = isUnassignedGroup;
						ElementUtil.query(toolbar, 'history').disabled = isUnassignedGroup;
						ElementUtil.query(toolbar, 'unitsInGroup').disabled = false;
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true;
						ElementUtil.enableDisableAction(toolbar, 'toggleStatus', true);
						ElementUtil.query(toolbar, 'manageUnits').disabled = true;
						ElementUtil.query(toolbar, 'history').disabled = true;
						ElementUtil.query(toolbar, 'unitsInGroup').disabled = true;
					}					
				}
			}
		});	
			
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 50,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
												
						grid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'driverRefNo',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',							
							status: ElementUtil.query(toolbarFilter, 'status').value,
							filterField: ElementUtil.query(toolbarFilter, 'filterType').value,
							filterValue: ElementUtil.query(toolbarFilter, 'filterValue').value							
						};
																		
						var successHandler = function(records) {
							loadMask.remove();
							grid.activeItem = null;						
							grid.items = records.data;

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();						
						};
						
						UnitService.getUnitGroupService().getUnitGroups(grid.currentFilter).then(function(records){
							successHandler(records);
						});						
					};	
					
					loadData();
														
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();					
				}
			}
			
		});

		var exportToolbar = ElementUtil.create({
			tag: 'dl-export-toolbar',
			itemid: 'primary',
			children: [
			],
			listeners: {
				ready: function() {
					exportToolbar.updateGrid(grid);
				},
				'click-detail': function() {
					actionExportGroups();
				}
			}
		});

		var footerContainer = ElementUtil.create({
			tag: 'div',
			slot: 'footer',
			children: [
				exportToolbar,
				{
					tag: 'div',
					style: 'border-top: 1px solid lightgrey;'
				},
				pagingToolbar
			]
		});
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbarContainer,
				grid,
				footerContainer
			]
		});		
		unitGroupGrid.append(flexLayout);		
			
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);	
		};

		attachWorkspaceFilterState(unitGroupGrid, toolbarFilter, ['filterType','filterValue','status'], actionRefresh);
					
		var actionAddEdit = function(record) {
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: record ? 'Edit Group' : 'Add Group',
				icon: 'vaadin:edit',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						addEditWin.show();
						
						var autoRules = [];
						
						var ruleToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',							
							children: [
								{
									tag: 'dl-action-button',
									itemid: 'add',
									theme: 'primary',
									'class': 'spacer-toolbar-item',					
									permissions: ['UNITGROUP_MANAGEMENT:WRITE'],
									children:[
										ElementUtil.makeIcon('vaadin:plus', ' Add')						
									],
									listeners: {
										click: function() {
											actionAddEditRule();
										}
									}					
								},
								{
									tag: 'dl-action-button',
									itemid: 'edit',
									'class': 'spacer-toolbar-item',
									disabled: true,	
									permissions: ['UNITGROUP_MANAGEMENT:WRITE'],
									children:[
										ElementUtil.makeIcon('vaadin:edit', ' Edit')						
									],
									listeners: {
										click: function() {
											actionAddEditRule(ruleGrid.selectedItems[0]);
										}
									}					
								},
								{
									tag: 'div',
									style: 'float: right;',
									children:[											
										{
											tag: 'dl-action-button',
											itemid: 'delete',
											disabled: true,
											theme: 'error primary',
											'class': 'spacer-toolbar-item',					
											permissions: ['UNITGROUP_MANAGEMENT:WRITE'], //this is intentional							
											children:[
												ElementUtil.makeIcon('vaadin:trash', 'Remove')						
											],
											listeners: {
												click: function() {
													actionDeleteRule(ruleGrid.selectedItems[0]);
												}
											}							
										}
									]
								}											
							]
						});	
						
						var ruleGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'wrap-cell-content row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',
							'rows-draggable': true,
							'drop-mode': 'between',	
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true,
								listeners: {
									'direction-changed': function (event) {
										if (event.detail && event.detail.value) {
											ruleGrid.currentSortField = event.target.path;
											ruleGrid.currentSortDirection = event.detail.value.toUpperCase();										
										}
									}
								}
							},
							children: [
								{
									path: 'field',
									header: 'Field',
									width: '7em'
								},
								{
									path: 'matchValue',
									header: 'Match Value',
									width: '9em'
								},
								{
									path: 'filterOperation',
									header: 'Filter Operation',
									width: '7em'
								},
								{
									path: 'referenceType',
									header: 'Reference Type',
									width: '7em'
								},
								{
									path: 'mergeOperator',
									header: 'Merge Operator',
									width: '7em'
								},								
								{
									path: 'caseInsensitive',
									header: 'Case Insensitive',
									width: '7em'
								}
							],
							listeners: {
								'active-item-changed': function (event) {
									const item = event.detail.value;
									ruleGrid.selectedItems = item ? [item] : [];
									if (ruleGrid.selectedItems.length > 0) {
										ElementUtil.query(ruleToolbar, 'edit').disabled = false;
										ElementUtil.query(ruleToolbar, 'delete').disabled = false;
									} else {
										ElementUtil.query(ruleToolbar, 'edit').disabled = true;
										ElementUtil.query(ruleToolbar, 'delete').disabled = true;
									}
								},
								'grid-dragstart': function(event) {
									this.draggedItem = event.detail.draggedItems[0];
								},
								'grid-dragend': function(event) {
									delete this.draggedItem;
								},
								'grid-drop': function(event) {
									const {dropTargetItem, dropLocation} = event.detail;
									// only act when dropping on another item
									if (this.draggedItem && dropTargetItem !== this.draggedItem) {
										// remove the item from its previous position
										const draggedItemIndex = this.items.indexOf(this.draggedItem);
										this.items.splice(draggedItemIndex, 1);
										// re-insert the item at its new position
										const dropIndex = this.items.indexOf(dropTargetItem) + (dropLocation === 'below' ? 1 : 0);
										this.items.splice(dropIndex, 0, this.draggedItem);
										// re-assign the array to refresh the grid
										this.items = [...this.items];
										
										autoRules = this.items.slice();
									}								
								}
							}
						});						
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-text-field',										
											name: 'groupName',
											label: 'Name',
											required: true,
											maxLength: 120											
										},
										{
											tag: 'vaadin-text-field',										
											name: 'groupCode',
											label: 'Group Code',
											maxLength: 120											
										},	
										{
											tag: 'vaadin-text-field',										
											name: 'description',
											label: 'Description',
											required: true,
											maxLength: 255
										},
										{
											tag: 'vaadin-text-field',										
											name: 'contactName',
											label: 'Contact Name',
											maxLength: 120
										},
										{
											tag: 'vaadin-text-field',										
											name: 'email',
											label: 'Email Address',
											maxLength: 255,
											'helper-text': 'comma-separated'
										},
										{
											tag: 'vaadin-text-field',										
											name: 'addrLine1',
											label: 'Address Line 1',
											maxLength: 120
										},
										{
											tag: 'vaadin-text-field',										
											name: 'addrLine2',
											label: 'Address Line 2',
											maxLength: 120
										},
										{
											tag: 'vaadin-text-field',										
											name: 'addrLine3',
											label: 'Address Line 3',
											maxLength: 120
										},
										{
											tag: 'vaadin-text-field',										
											name: 'city',
											label: 'City',
											maxLength: 120
										},										
										{
											tag: 'vaadin-combo-box',
											itemid: 'stateProvCodeCB',
											label: 'State/Providence',
											name: 'stateProvCode',
											'item-value-path': 'code',
											'item-label-path': 'description',										
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('StateProvCode').then(function (data) {
													combo.items = data;
												});
											}
										},
										{
											tag: 'vaadin-text-field',										
											name: 'postalCode',
											label: 'Postal Code',
											maxLength: 20
										},
										{
											tag: 'vaadin-checkbox',
											itemid: 'unassignedUnitGroupCB',
											name: 'unassignedUnitGroup',
											label: 'Unassigned Unit Group',
											colspan: 2,
											listeners: {
												change: function(event) {
													applyUnassignedGroupUi(event.target.checked);
												}
											}
										}
									]
								},	
								{
									tag: 'fieldset',
									itemid: 'matchingUnitOptions',
									colspan: 2,
									children: [
										{
											tag: 'legend',
											innerHTML: 'Matching Unit Options'
										},
										{
											tag: 'vaadin-checkbox',									
											name: 'excludeTractorHistory',
											label: 'Exclude Tractor History'
										},
										{
											tag: 'br'
										},
										{
											tag: 'vaadin-checkbox',									
											name: 'tractorUseLastState',
											label: 'Use Last Tractor State'
										}													
									]
								},
								{
									tag: 'vaadin-checkbox',
									itemid: 'ignoreGroupSwitchCB',
									name: 'ignoreGroupSwitch',
									label: 'Ignore Group Switch'
								},
								{
									tag: 'dl-section-title',
									itemid: 'matchingRulesTitle',
									title: 'Unit Matching Rules (Optional)',
									colspan: 2,
									style: 'margin-top: 20px;'
								},
								{
									tag: 'div',
									itemid: 'matchingRulesSection',
									style: 'height: 300px;',
									colspan: 2,
									children: [
										{
											tag: 'dl-flex-layout',
											children: [
												ruleToolbar,
												ruleGrid
											]
										}
									]
								},
								{	
									tag: 'vaadin-form-layout',										
									children: [		
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
																		
																													
															formPanel.submitForm({
																preSubmit: function(data) {			
																	var stateCB = ElementUtil.query(formPanel, 'stateProvCodeCB');
																	
																	if (stateCB.selectedItem) {
																		data.countryCode = stateCB.selectedItem.country;																	
																	} else {
																		delete data.stateProvCode;
																	}
																	var unassignedChecked = ElementUtil.query(formPanel, 'unassignedUnitGroupCB').checked;
																	data.unassignedUnitGroup = unassignedChecked === true;
																	if (unassignedChecked) {
																		data.autoRules = [];
																		data.excludeTractorHistory = false;
																		data.tractorUseLastState = false;
																		data.ignoreGroupSwitch = false;
																	} else {
																		data.autoRules = autoRules;
																	}
																	return data;
																},
																actualCall: function(data) {			
																	if (record) {
																		data.unitGroupId = record.unitGroupId;																		
																	}
																	return UnitService.getUnitGroupService().saveUnitGroup(data, (record ? true : false));
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Unit Group', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	actionRefresh();
																	addEditWin.close();
																}
															});															
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);

						var actionRefreshRules = function() {	
							ruleGrid.items = autoRules.slice();														
						};

						var companyAlreadyHasUnassigned = function() {
							var groups = grid.items || [];
							for (var index = 0; index < groups.length; index++) {
								if (groups[index].unassignedUnitGroup === true
										&& (!record || groups[index].unitGroupId !== record.unitGroupId)) {
									return true;
								}
							}
							return false;
						};

						var applyUnassignedGroupUi = function(checked) {
							var display = checked ? 'none' : '';
							ElementUtil.query(formPanel, 'matchingUnitOptions').style.display = display;
							ElementUtil.query(formPanel, 'ignoreGroupSwitchCB').style.display = display;
							ElementUtil.query(formPanel, 'matchingRulesTitle').style.display = display;
							ElementUtil.query(formPanel, 'matchingRulesSection').style.display = display;
							if (checked) {
								var nameField = formPanel.querySelector('[name="groupName"]');
								var descriptionField = formPanel.querySelector('[name="description"]');
								if (nameField && !nameField.value) {
									nameField.value = 'Unassigned Unit Group';
								}
								if (descriptionField && !descriptionField.value) {
									descriptionField.value = 'Unassigned Unit Group';
								}
								autoRules = [];
								actionRefreshRules();
							}
						};
						
						if (record) {	
							formPanel.load(record);
							autoRules = record.autoRules || [];
							var unassignedCheckbox = ElementUtil.query(formPanel, 'unassignedUnitGroupCB');
							unassignedCheckbox.checked = record.unassignedUnitGroup === true;
							unassignedCheckbox.disabled = true;
							applyUnassignedGroupUi(record.unassignedUnitGroup === true);
						} else if (companyAlreadyHasUnassigned()) {
							var unassignedOnlyOnce = ElementUtil.query(formPanel, 'unassignedUnitGroupCB');
							unassignedOnlyOnce.disabled = true;
							unassignedOnlyOnce.title = 'An unassigned unit group already exists for this company.';
						}
						
						actionRefreshRules();
						
						var actionAddEditRule = function(rule) {
						
							var addEditRuleWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: rule ? 'Edit Rule' : 'Add Rule',
								icon: 'vaadin:edit',
								width: 600,
								height: 500,
								listeners: {
									ready: function () {
										addEditRuleWin.show();

										var loadFieldDefs = function(referenceType) {
											var fieldCB = ElementUtil.query(formPanelRules, 'field');
											
											UnitService.getUnitGroupService().getMatchingFields(referenceType).then(function(data){												
												data.dataField.sort(function(a, b){
													return a.name.localeCompare(b.name);
												});												
												
												fieldCB.items = data.dataField;												
											});
											
										};

										var formPanelRules = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-form-layout',
													children: [
														{										
															tag: 'vaadin-combo-box',
															itemid: 'referenceType',
															name: 'referenceType',
															label: 'Reference Type',
															'item-value-path': 'code',
															'item-label-path': 'description',
															value: 'TRACTOR',														
															postinit: function(combo) {						
																Service.getLookupService().getLookupValues('ReferenceType').then(function (data) {
																	
																	var unitRefs = [];
																	data.forEach(function(reference){
																		if (reference.unitReference) {
																			unitRefs.push(reference);
																		}
																	});
																	
																	combo.items = unitRefs;
																	combo.required = true;
																	
																});					
															},
															placeHolder: 'Select',
															listeners: {
																change: function(e) {
																	var refCB = e.target;																																		
																	loadFieldDefs(refCB.value);
																}
															}
														},
														{										
															tag: 'vaadin-combo-box',
															itemid: 'field',	
															name: 'field',
															label: 'Field',
															'item-value-path': 'fieldPath',
															'item-label-path': 'name',		
															required: true,
															postinit: function(combo) {	
																setTimeout(function(){
																	loadFieldDefs('TRACTOR');
																}, 50);																
															},
															placeHolder: 'Select'					
														},
														{
															tag: 'vaadin-text-field',
															name: 'matchValue',
															label: 'Match Value',
															required: true,
															maxLength: 255
														},
														{										
															tag: 'vaadin-combo-box',
															itemid: 'filterOperation',
															name: 'filterOperation',
															label: 'Filter Opeation',
															'item-value-path': 'code',
															'item-label-path': 'description',
															required: true,
															postinit: function(combo) {						
																Service.getLookupService().getLookupValues('FilterOperation').then(function (data) {
																	combo.items = data;
																});					
															},
															placeHolder: 'Select'					
														},
														{										
															tag: 'vaadin-combo-box',
															itemid: 'mergeOperator',
															name: 'mergeOperator',
															label: 'Merge Operation',
															'item-value-path': 'code',
															'item-label-path': 'description',
															value: 'AND',														
															postinit: function(combo) {						
																Service.getLookupService().getLookupValues('MergeOperator').then(function (data) {
																	combo.items = data;
																	combo.required = true;
																});					
															},
															placeHolder: 'Select'					
														},
														{
															tag: 'vaadin-checkbox',
															name: 'caseInsensitive',
															checked: true,
															label: 'Case Insensitive'
														}
													]
												},		
												{
													tag: 'vaadin-form-layout',
													children: [
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:database', ' Save')
																	],
																	listeners: {
																		click: function () {
																			
																			var data = formPanelRules.getData(); 
																			
																			var fieldCB = ElementUtil.query(formPanelRules, 'field');
																			if (fieldCB.selectedItem) {
																				data.fieldType = fieldCB.selectedItem.fieldType;
																			} 
																			
																			if (rule) {
																				rule.field = data.field;
																				rule.fieldType = data.fieldType;
																				rule.keyValue = data.keyValue;
																				rule.matchValue = data.matchValue;
																				rule.filterOperation = data.filterOperation;
																				rule.referenceType = data.referenceType;
																				rule.mergeOperator = data.mergeOperator;
																				rule.caseInsensitive = data.caseInsensitive;
																			} else {
																				autoRules.push(data);
																			}
																			actionRefreshRules();
																			addEditRuleWin.close();

																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function () {
																			//cancel
																			addEditRuleWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]
										});

										addEditRuleWin.addToContentElement(formPanelRules);

										if (rule) {
											formPanelRules.load(rule);
										}
									}
								}
							});
						};
						
						var actionDeleteRule = function(rule) {
							
							window.DL.MessageUtil.showConfirm({
								title: 'Confirm Delete',
								message: 'Are you sure you want to delete selected rule?',
								buttons: [
									{
										text: 'Yes',
										handler: function() {
											
											var rulesToKeep = [];
											autoRules.forEach(function(autoRule){
												var keep = true;
												if (autoRule.field === rule.field && 
													autoRule.fieldType === rule.fieldType && 
													autoRule.matchValue === rule.matchValue && 
													autoRule.keyValue === rule.keyValue && 
													autoRule.filterOperation === rule.filterOperation && 
													autoRule.referenceType === rule.referenceType && 
													autoRule.mergeOperator === rule.mergeOperator &&
													autoRule.caseInsensitive === rule.caseInsensitive) {												
													keep = false;
												}
												if (keep) {
													rulesToKeep.push(autoRule);
												}
											});
											autoRules = rulesToKeep;
											actionRefreshRules();
					
										}
									},
									{
										text: 'No'
									}
								]
							});							
							
						};						
						
					}
				}
			});			
		};
		
		var actionDelete = function(record) {
	
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: '<b>Are you sure you want to delete "' + record.groupName + '"?</b> <br><i class="fas fa-exclamation-triangle warning-icon"></i>Group will no longer show on historic data.',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing...');

							UnitService.getUnitGroupService().deleteUnitGroup(record.unitGroupId)
							.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed '+ record.groupName, {									
									theme: 'success'
								});
								actionRefresh();
							}, function(error) {
								loadMask.remove();
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});
		
		};	
		
		var actionUpdateStatus = function(record) {
			
			if (record.activeStatus === 'A') {
				UnitService.getUnitGroupService().inactivateUnitGroup(record.unitGroupId).then(function(data){
					window.DL.MessageUtil.showToast('Success', 'InActivated ' + record.groupName, {									
						theme: 'success'
					});
					actionRefresh();
				});				
			} else {
				UnitService.getUnitGroupService().activateUnitGroup(record.unitGroupId).then(function(data){
					window.DL.MessageUtil.showToast('Success', 'Activated ' + record.groupName, {									
						theme: 'success'
					});
					actionRefresh();
				});
			}
			
		};

		var actionExportGroups = function() {
			var exportFilter = Object.assign({}, grid.currentFilter || {});
			delete exportFilter.offset;
			delete exportFilter.max;
			UnitService.getUnitGroupService().exportUnitGroups(exportFilter);
		};

		var actionImportGroups = function() {
			var uploadWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Import Unit Groups',
				icon: 'vaadin:upload',
				width: 450,
				height: 235,
				listeners: {
					ready: function () {
						uploadWin.show();

						var uploadHandler = function () {
							var uploadField = ElementUtil.query(uploadFormPanel, 'uploadField');

							if (!uploadField.files || uploadField.files.length < 1) {
								window.DL.MessageUtil.showOkMessage('A unit group import file is required.');
							} else {
								uploadField.uploadFiles();
							}
						};

						var uploadFormPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-upload',
									itemid: 'uploadField',
									'no-auto': true,
									'max-files': 1,
									required: true,
									target: '/api/resource/unit-groups/import',
									headers: ImportUtil.getUploadHeader(),
									listeners: {
										'upload-request': function (event) {
										},
										'upload-success': function (event) {
											var responseData = JSON.parse(event.detail.xhr.responseText);
											if (responseData.uploadFile) {
												window.DL.MessageUtil.showOkMessage(
														responseData.uploadFile + '<br>' +
														responseData.uploadFileType ? responseData.uploadFileType : ''
														);
											} else {
												window.DL.MessageUtil.showToast('Success', 'Uploaded Successfully.<br>The import will be processed on Task queue.', {
													theme: 'success',
													position: 'top-stretch'
												});
												uploadWin.close();
											}
										}
									}
								},
								{
									tag: 'vaadin-form-layout',
									children: [
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:upload', ' Upload')
													],
													listeners: {
														click: function () {
															if (uploadFormPanel.isValid()) {
																uploadHandler();
															}
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function () {
															uploadWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});

						uploadWin.addToContentElement(uploadFormPanel);
					}
				}
			});
		};

		var actionImportAssignments = function() {
			var uploadWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Import Unit Group Assignments',
				icon: 'vaadin:upload',
				width: 720,
				height: 500,
				listeners: {
					ready: function () {
						uploadWin.show();

						var uploadHandler = function () {
							var uploadField = ElementUtil.query(uploadFormPanel, 'uploadField');

							if (!uploadField.files || uploadField.files.length < 1) {
								window.DL.MessageUtil.showOkMessage('An assignment import file is required.');
							} else {
								uploadField.uploadFiles();
							}
						};

						var uploadFormPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-upload',
									itemid: 'uploadField',
									'no-auto': true,
									'max-files': 1,
									required: true,
									target: '/api/resource/unit-groups/assignments/import',
									headers: ImportUtil.getUploadHeader(),
									listeners: {
										'upload-request': function (event) {
										},
										'upload-success': function (event) {
											var responseData = JSON.parse(event.detail.xhr.responseText);
											if (responseData.uploadFile) {
												window.DL.MessageUtil.showOkMessage(
														responseData.uploadFile + '<br>' +
														responseData.uploadFileType ? responseData.uploadFileType : ''
														);
											} else {
												window.DL.MessageUtil.showToast('Success', 'Uploaded Successfully.<br>The import will be processed in the background.<br>Watch Notifications', {
													theme: 'success',
													position: 'top-stretch'
												});
												uploadWin.close();
											}
										}
									}
								},
								{
									tag: 'vaadin-details',
									opened: true,
									summary: 'Format Details',
									children: [
										{
											tag: 'div',
											style: 'font-size: 0.9em; line-height: 1.4;',
											innerHTML:
												' - <b>Columns:</b> Unit Ref No, Reference Type, Group Name, Action, History Action, History<br>' +
												' - <b>Reference Type:</b> optional; default TRACTOR (DRIVER / TRAILER also supported)<br>' +
												' - <b>Group Name:</b> group name or group code. Blank = unassigned (skipped on import)<br>' +
												' - <b>Action:</b> A = add to group, X = remove from that group, blank = no membership change<br>' +
												' - <b>History Action:</b> R = replace, A = append, RB = replace only when History is non-blank (default)<br>' +
												' - <b>History:</b> start|end: start|end: … (empty end allowed)<br>' +
												' - <b>Dates (company timezone unless z is present):</b><br>' +
												'     MM/dd/yyyy (start of day / end of day), MM/dd/yyyy HH:mm:ss, or MM/dd/yyyy HH:mm:ss z<br>' +
												' - <i>Generate a starter file from Reports → Unit Group Assignments export.</i>'
										}
									]
								},
								{
									tag: 'vaadin-form-layout',
									children: [
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:upload', ' Upload')
													],
													listeners: {
														click: function () {
															if (uploadFormPanel.isValid()) {
																uploadHandler();
															}
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function () {
															uploadWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});

						uploadWin.addToContentElement(uploadFormPanel);
					}
				}
			});
		};
		
		var actionManageUnits = function(record) {
			var addUnitsWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Manage Direct Units',
				icon: 'vaadin:truck',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						addUnitsWin.show();
						
						var selectFilterToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [
								{
									tag: 'vaadin-combo-box',
									itemid: 'referenceType',
									name: 'referenceType',
									label: 'Reference Type',
									'item-value-path': 'code',
									'item-label-path': 'description',
									value: 'TRACTOR',									
									postinit: function (combo) {
										Service.getLookupService().getLookupValues('ReferenceType').then(function (data) {

											var unitRefs = [];
											data.forEach(function (reference) {
												if (reference.unitReference) {
													unitRefs.push(reference);
												}
											});

											combo.items = unitRefs;
											combo.required = true;
										});
									},
									placeHolder: 'Select',
									listeners: {
										change: function() {
											actionSelectGrid();
										}
									}
								},
								{										
									tag: 'vaadin-combo-box',
									itemid: 'filterType',
									'class': 'spacer-toolbar-item',
									'keep-open': true,
									style: 'width: 200px;',
									label: 'Filter By',
									'item-value-path': 'code',
									'item-label-path': 'description',
									required: true,
									value: 'description',
									postinit: function (combo) {						
										var lookups = [											
											{
												code: 'description',
												description: 'Reference No'
											},
											{
												code: 'tags',
												description: 'Tag'
											}
										];
										combo.items = lookups;
									},
									placeHolder: 'Select'
								},
								
								{
									tag: 'vaadin-text-field',
									itemid: 'filterValue',
									'class': 'spacer-toolbar-item',
									'keep-open': true,
									label: 'Value',
									listeners: {
										input: {
											fn: function() {
												actionSelectGrid();
											},
											buffer: 2000
										}
									}
								}								
							]
						});	
						
						var selectToolbarContainer = ElementUtil.create({
							tag: 'div',
							slot: 'toolbar',
							children: [
								{
									tag: 'dl-section-title',
									title: 'Available',									
									style: 'margin-top: 20px;'
								},
								selectFilterToolbar
							]
						});						
																		
						var selectGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'wrap-cell-content row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',
							'rows-draggable': true,
							'drop-mode': 'on-grid',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true,
								listeners: {
									'direction-changed': function (event) {
										if (event.detail && event.detail.value) {
											selectGrid.currentSortField = event.target.path;
											selectGrid.currentSortDirection = event.detail.value.toUpperCase();
											selectPagingToolbar.loadCurrentPage();
										}
									}
								}
							},
							children: [	
								{
									tag: 'vaadin-grid-selection-column',
									itemid: 'selectionColumn',
									'auto-select': true,
									'auto-width': true,
									listeners: {
										'select-all-changed': function () {
											
										}
									}
								},
								{
									path: 'description',
									header: 'Unit Ref No',
									width: '9em'
								}
							],
							listeners: {
								'active-item-changed': function (event) {
									const item = event.detail.value;
									//selectGrid.selectedItems = item ? [item] : [];
									
								},
								'grid-dragstart': function(event) {
									selectGrid.draggedItems = event.detail.draggedItems;
								},
								'grid-dragend': function(event) {
									delete selectGrid.draggedItems;
								},
								'grid-drop': function(event) {
									const draggedUnits = inGrid.draggedItems;
									
									var unitsRefIds = [];
									if (draggedUnits) {
										draggedUnits.forEach(function (item) {
											unitsRefIds.push(item.unitGroupRefId);
										});


										var loadMask = addUnitsWin.getContentElement().showLoading('Removing...');
										UnitService.getUnitGroupService().deleteUnitsInGroup(record.unitGroupId, unitsRefIds).then(function () {
											loadMask.remove();

											actionRefreshInGrid();
											actionSelectGrid();
										}, function () {
											loadMask.remove();
										});
									}
								}
							}
						});
						
						var selectPagingToolbar = ElementUtil.create({
							tag: 'dl-paging-toolbar',
							slot: 'footer',
							pageSize: 100,
							postinit: function(element) {
								element.grid = selectGrid;
								element.loader = function(backingGrid, pageNumber, pagingToolbar) {
									var pageRange = pagingToolbar.pullRange();
									var loadMask = selectGrid.showLoading();

									var loadData = function() {

										selectGrid.currentFilter = {
											offset: pageRange.offset,
											max: pageRange.max,
											sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'description',
											sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',																	
											filterField: ElementUtil.query(selectFilterToolbar, 'filterType').value,
											filterValue: ElementUtil.query(selectFilterToolbar, 'filterValue').value
										};

										var successHandler = function(records) {
											loadMask.remove();
											selectGrid.activeItem = null;						
											selectGrid.items = records.data;

											selectPagingToolbar.totalRecords = records.totalNumber;
											selectPagingToolbar.updatePager();						
										};

										var referenceType = ElementUtil.query(selectFilterToolbar, 'referenceType').value;
										if (!referenceType) {
											referenceType = 'TRACTOR';
										}

										UnitService.getUnitGroupService().getAvalibleDirectUnits(record.unitGroupId, referenceType, selectGrid.currentFilter).then(function(records){
											successHandler(records);
										});						
									};	

									loadData();

								};
							},
							listeners: {
								ready: function() {					
									selectPagingToolbar.loadCurrentPage();					
								}
							}

						});
						
						var inFilterToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [								
								{
									tag: 'vaadin-text-field',
									itemid: 'filterUnitRefNo',
									'class': 'spacer-toolbar-item',
									'keep-open': true,
									label: 'Unit Ref No',
									listeners: {
										input: {
											fn: function() {
												actionRefreshInGrid();
											},
											buffer: 2000
										}
									}
								}								
							]
						});	
						
						var inToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [
								{
									tag: 'dl-action-button',
									itemid: 'import',
									'class': 'spacer-toolbar-item',
									permissions: ['UNITGROUP_MANAGEMENT:WRITE'],
									children: [
										ElementUtil.makeIcon('vaadin:download', ' Import')
									],
									listeners: {
										click: function () {
											actionImportUnits();
										}
									}
								},
								{
									tag: 'div',
									style: 'float: right;',
									children: [
										{
											tag: 'dl-action-button',
											itemid: 'export',
											'class': 'spacer-toolbar-item',
											permissions: ['UNITGROUP_MANAGEMENT:READ'],
											children: [
												ElementUtil.makeIcon('vaadin:upload', ' Export')
											],
											listeners: {
												click: function () {
													actionExportUnits();
												}
											}
										}
									]
								}											
							]
						});						
						
						var inToolbarContainer = ElementUtil.create({
							tag: 'div',
							slot: 'toolbar',
							children: [
								{
									tag: 'dl-section-title',
									title: 'In Group',									
									style: 'margin-top: 20px;'
								},
								inFilterToolbar,
								ElementUtil.create({
									tag: 'hr'
								}),
								inToolbar
							]
						});	

						var inGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'wrap-cell-content row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',
							'rows-draggable': true,
							'drop-mode': 'on-grid',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true,
								listeners: {
									'direction-changed': function (event) {
										if (event.detail && event.detail.value) {
											inGrid.currentSortField = event.target.path;
											inGrid.currentSortDirection = event.detail.value.toUpperCase();	
											inPagingToolbar.loadCurrentPage();
										}
									}
								}
							},
							children: [
								{
									tag: 'vaadin-grid-selection-column',
									itemid: 'selectionColumn',
									'auto-select': true,
									'auto-width': true,
									listeners: {
										'select-all-changed': function () {										
										}
									}
								},
								{
									path: 'referenceType',
									header: 'Reference Type',
									width: '7em'
								},
								{
									path: 'unitRefNo',
									header: 'Unit Ref No',
									width: '9em'
								}
							],
							listeners: {
								'active-item-changed': function (event) {
									const item = event.detail.value;
									inGrid.selectedItems = item ? [item] : [];																			
								},
								'grid-dragstart': function(event) {
									inGrid.draggedItems = event.detail.draggedItems;
								},
								'grid-dragend': function(event) {
									delete this.draggedItems;
								},
								'grid-drop': function(event) {
									const draggedUnits = selectGrid.draggedItems;
								  								  
									var units = [];
									if (draggedUnits) {
										draggedUnits.forEach(function (item) {
											units.push({
												unitGroupId: record.unitGroupId,
												referenceType: ElementUtil.query(selectFilterToolbar, 'referenceType').value,
												unitId: item.code
											});
										});

										var loadMask = addUnitsWin.getContentElement().showLoading('Saving...');
										UnitService.getUnitGroupService().addUnitsToGroup(record.unitGroupId, units).then(function () {
											loadMask.remove();

											actionRefreshInGrid();
											actionSelectGrid();
										}, function () {
											loadMask.remove();
										});
									}
									
								}
							}
						});	
						
						var inPagingToolbar = ElementUtil.create({
							tag: 'dl-paging-toolbar',
							slot: 'footer',
							pageSize: 100,
							postinit: function(element) {
								element.grid = inGrid;
								element.loader = function(backingGrid, pageNumber, pagingToolbar) {
									var pageRange = pagingToolbar.pullRange();
									var loadMask = inGrid.showLoading();

									var loadData = function() {

										inGrid.currentFilter = {
											offset: pageRange.offset,
											max: pageRange.max,
											sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'unitRefNo',
											sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',																	
											filterField: 'unitRefNo',
											filterValue: ElementUtil.query(inFilterToolbar, 'filterUnitRefNo').value
										};

										var successHandler = function(records) {
											loadMask.remove();
											inGrid.activeItem = null;						
											inGrid.items = records.data;

											inPagingToolbar.totalRecords = records.totalNumber;
											inPagingToolbar.updatePager();						
										};

										UnitService.getUnitGroupService().getDirectUnitGroupRef(record.unitGroupId, inGrid.currentFilter).then(function(records){
											successHandler(records);
										});						
									};	

									loadData();

								};
							},
							listeners: {
								ready: function() {					
									inPagingToolbar.loadCurrentPage();					
								}
							}

						});
						
						var splitLayout = ElementUtil.create({
							tag: 'vaadin-split-layout',				
							slot: 'primary',
							style: 'height: 100%;',
							children: [
								{
									tag: 'dl-flex-layout',
									children: [
										selectToolbarContainer,
										selectGrid,
										selectPagingToolbar
									]
								},
								{
									tag: 'dl-flex-layout',
									children: [
										inToolbarContainer,
										inGrid,
										inPagingToolbar
									]
								}
							]
						});						
						
						var unitFlexLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								splitLayout
							]
						});
						addUnitsWin.addToContentElement(unitFlexLayout);
						
						var actionSelectGrid = function() {
							selectPagingToolbar.loadPage(1);	
						};
												
						var actionRefreshInGrid = function() {
							inPagingToolbar.loadPage(1);
						};
						
						var actionImportUnits = function() {
							var uploadWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Import Units into Group',
								icon: 'vaadin:upload',
								width: 450,
								height: 235,
								listeners: {
									ready: function () {
										uploadWin.show();

										var uploadHandler = function () {

											var uploadField = ElementUtil.query(uploadFormPanel, 'uploadField');

											if (!uploadField.files || uploadField.files.length < 1) {
												window.DL.MessageUtil.showOkMessage('A group unit import file is required.');
											} else {
												uploadField.uploadFiles();
											}

										};

										var uploadFormPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-upload',
													itemid: 'uploadField',
													'no-auto': true,
													'max-files': 1,
													required: true,
													target: '/api/resource/unit-groups/' + record.unitGroupId + '/units/import',
													headers: ImportUtil.getUploadHeader(),
													listeners: {
														'upload-request': function (event) {
														},
														'upload-success': function (event) {
															var responseData = JSON.parse(event.detail.xhr.responseText);
															if (responseData.uploadFile) {
																//error 
																window.DL.MessageUtil.showOkMessage(
																		responseData.uploadFile + '<br>' +
																		responseData.uploadFileType ? responseData.uploadFileType : ''
																		);
															} else {
																window.DL.MessageUtil.showToast('Success', 'Uploaded Successfully.<br>The import will be processed on Task queue.', {
																	theme: 'success',
																	position: 'top-stretch'
																});
																uploadWin.close();
															}
														}
													}
												},
												{
													tag: 'vaadin-form-layout',
													children: [
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:upload', ' Upload')
																	],
																	listeners: {
																		click: function () {
																			if (uploadFormPanel.isValid()) {
																				uploadHandler();
																			}
																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function () {
																			uploadWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]
										});
										uploadWin.addToContentElement(uploadFormPanel);

									}
								}
							});
						};
						
						var actionExportUnits = function() {
							UnitService.getUnitGroupService().exportUnits(record.unitGroupId, inGrid.currentFilter);
						};
					}
				}
			});			
		};
		
		var actionHistory = function(record) {
			var addHistoryWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'History',
				icon: 'vaadin:clock',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						addHistoryWin.show();
						
						var historyFilterToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [
								{
									tag: 'vaadin-date-picker',
									'class': 'spacer-toolbar-item',
									itemid: 'filterStartDate',
									label: 'Filter Start Date',												
									name: 'filterStartDate',
									value: function() {
										return TimeUtil.formatDateForTimeField(TimeUtil.startPreviousMonth());	
									}()
								},
								{
									tag: 'vaadin-date-picker',
									'class': 'spacer-toolbar-item',
									itemid: 'filterEndDate',
									label: 'Filter End Date',												
									name: 'filterEndDate',
									value: function() {
										return TimeUtil.formatDateForTimeField(TimeUtil.endPreviousMonth());	
									}()
								},
								{
									tag: 'vaadin-text-field',
									itemid: 'filterUnitRefNo',
									'class': 'spacer-toolbar-item',
									'keep-open': true,
									label: 'Unit Ref No',
									listeners: {
										input: {
											fn: function() {
												actionRefreshHistory();
											},
											buffer: 2000
										}
									}
								},
								{
									tag: 'vaadin-button',
									itemid: 'refresh',
									'class': 'spacer-toolbar-item',
									children:[
										ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
									], 
									listeners: {
										click: function() {
											actionRefreshHistory();
										}
									}
								}								
							]
						});	
						
						var historyToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [
								{
									tag: 'dl-action-button',
									itemid: 'add',
									theme: 'primary',
									'class': 'spacer-toolbar-item',					
									permissions: ['UNITGROUP_MANAGEMENT:WRITE'],
									children:[
										ElementUtil.makeIcon('vaadin:plus', ' Add')						
									],
									listeners: {
										click: function() {
											actionAddEditHistory();
										}
									}					
								},
								{
									tag: 'dl-action-button',
									itemid: 'edit',
									'class': 'spacer-toolbar-item',
									disabled: true,	
									permissions: ['UNITGROUP_MANAGEMENT:WRITE'],
									children:[
										ElementUtil.makeIcon('vaadin:edit', ' Edit')						
									],
									listeners: {
										click: function() {
											actionAddEditHistory(historyGrid.selectedItems[0]);
										}
									}					
								},
								{
									tag: 'dl-action-button',
									itemid: 'import',
									'class': 'spacer-toolbar-item',									
									permissions: ['UNITGROUP_MANAGEMENT:WRITE'],
									children:[
										ElementUtil.makeIcon('vaadin:download', ' Import')						
									],
									listeners: {
										click: function() {
											actionImportHistory();
										}
									}					
								},
								{
									tag: 'dl-action-button',
									itemid: 'export',
									'class': 'spacer-toolbar-item',									
									permissions: ['UNITGROUP_MANAGEMENT:READ'],
									children:[
										ElementUtil.makeIcon('vaadin:upload', ' Export')						
									],
									listeners: {
										click: function() {
											actionExportHistory();
										}
									}					
								},								
								{
									tag: 'div',
									style: 'float: right;',
									children:[											
										{
											tag: 'dl-action-button',
											itemid: 'delete',
											disabled: true,
											theme: 'error primary',
											'class': 'spacer-toolbar-item',					
											permissions: ['UNITGROUP_MANAGEMENT:DELETE'],							
											children:[
												ElementUtil.makeIcon('vaadin:trash', 'Remove')						
											],
											listeners: {
												click: function() {
													actionDeleteHistory(historyGrid.selectedItems[0]);
												}
											}							
										}
									]
								}											
							]
						});	
						
						var allToolbars = ElementUtil.create({
							tag: 'div',
							slot: 'toolbar',
							children: [
								historyFilterToolbar,
								{
									tag: 'hr'
								},
								historyToolbar
							]
						});
						
						var historyGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'wrap-cell-content row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',							
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true,
								listeners: {
									'direction-changed': function (event) {
										if (event.detail && event.detail.value) {
											historyGrid.currentSortField = event.target.path;
											historyGrid.currentSortDirection = event.detail.value.toUpperCase();										
										}
									}
								}
							},
							children: [
								{
									path: 'referenceType',
									header: 'Reference Type',
									width: '7em'
								},
								{
									path: 'unitRefNo',
									header: 'Unit Ref No',
									width: '9em'
								},
								{						
									path: 'startDate',
									header: 'Start Date',
									width: '7em',					
									renderer: function(root, column, rowData) {
										if (rowData.item.startDate) {
											var date = TimeUtil.parseDate(rowData.item.startDate);												
											root.innerHTML = TimeUtil.formatDateStandard(date);						
										}
									}
								},
								{						
									path: 'endDate',
									header: 'End Date',
									width: '7em',					
									renderer: function(root, column, rowData) {
										if (rowData.item.endDate) {
											var date = TimeUtil.parseDate(rowData.item.endDate);												
											root.innerHTML = TimeUtil.formatDateStandard(date);								
										}
									}
								},								
								{
									path: 'comment',
									header: 'Comment',
									width: '7em'
								}
							],
							listeners: {
								'active-item-changed': function (event) {
									const item = event.detail.value;
									historyGrid.selectedItems = item ? [item] : [];		
									
									if (historyGrid.selectedItems.length > 0) {
										ElementUtil.query(historyToolbar, 'edit').disabled = false;
										ElementUtil.query(historyToolbar, 'delete').disabled = false;
									} else {
										ElementUtil.query(historyToolbar, 'edit').disabled = true;
										ElementUtil.query(historyToolbar, 'delete').disabled = true;
									}									
								}
							}
						});	
						
						var historyPagingToolbar = ElementUtil.create({
							tag: 'dl-paging-toolbar',
							slot: 'footer',
							pageSize: 100,
							postinit: function(element) {
								element.grid = historyGrid;
								element.loader = function(backingGrid, pageNumber, pagingToolbar) {
									var pageRange = pagingToolbar.pullRange();
									var loadMask = historyGrid.showLoading();

									var loadData = function() {

										var startFilterDts = TimeUtil.startOfDayCompanyTime(ElementUtil.query(historyFilterToolbar, 'filterStartDate').value);										
										var endFilterDts =  TimeUtil.endOfDayCompanyTime(ElementUtil.query(historyFilterToolbar, 'filterEndDate').value);		

										historyGrid.currentFilter = {
											offset: pageRange.offset,
											max: pageRange.max,
											sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'unitRefNo',
											sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',																	
											start: startFilterDts,														
											end: endFilterDts,
											dateField: 'startDate',
											filterField: 'unitRefNo',
											filterValue: ElementUtil.query(historyFilterToolbar, 'filterUnitRefNo').value
										};

										var successHandler = function(records) {
											loadMask.remove();
											historyGrid.activeItem = null;						
											historyGrid.items = records.data;

											historyPagingToolbar.totalRecords = records.totalNumber;
											historyPagingToolbar.updatePager();						
										};

										UnitService.getUnitGroupService().getGroupHistory(record.unitGroupId, historyGrid.currentFilter).then(function(records){
											successHandler(records);
										});						
									};	

									loadData();

								};
							},
							listeners: {
								ready: function() {					
									historyPagingToolbar.loadCurrentPage();					
								}
							}

						});	
						
						var actionRefreshHistory = function() {
							historyPagingToolbar.loadPage(1);
						};
						
						var historyFlexLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								allToolbars,
								historyGrid,
								historyPagingToolbar
							]
						});
						addHistoryWin.addToContentElement(historyFlexLayout);
						
						var actionAddEditHistory = function(history){
							var addEditHistoryWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: history ? 'Edit History' : 'Add History',
								icon: 'vaadin:edit',
								width: 600,
								height: 500,
								listeners: {
									ready: function () {
										addEditHistoryWin.show();

										var loadReferenceNo = function (refType, lookupValue, cbToPopulate) {
											var paging = {
												max: 100
											};
											if (lookupValue) {
												paging.filterField = 'description';
												paging.filterValue = lookupValue;
											}
											UnitService.getUnitLookupService().getUnits(refType, paging).then(function (units) {
												cbToPopulate.items = units.data;
											});

										};

										var formPanelHistory = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-form-layout',
													children: [
														{										
															tag: 'vaadin-combo-box',
															itemid: 'referenceType',
															name: 'referenceType',
															label: 'Reference Type',
															'item-value-path': 'code',
															'item-label-path': 'description',
															value: 'TRACTOR',															
															postinit: function(combo) {						
																Service.getLookupService().getLookupValues('ReferenceType').then(function (data) {
																	
																	var unitRefs = [];
																	data.forEach(function(reference){
																		if (reference.unitReference) {
																			unitRefs.push(reference);
																		}
																	});
																	
																	combo.items = unitRefs;
																	combo.required = true;																	
																});					
															},
															placeHolder: 'Select',
															listeners: {
																change: function(e) {
																	var typeCB = e.target;
																	var newValue = typeCB.value;

																	ElementUtil.query(formPanelHistory, 'unitIdCB').value = '';
																	var initRefNo = null;
																	if (e.detail) {
																		initRefNo = e.detail;
																	}
																	loadReferenceNo(newValue, initRefNo, ElementUtil.query(formPanelHistory, 'unitIdCB'));	
																}
															}
														},
														{										
															tag: 'vaadin-combo-box',
															itemid: 'unitIdCB',	
															name: 'unitId',
															label: 'Unit',
															'item-value-path': 'code',
															'item-label-path': 'description',		
															required: true,
															postinit: function(combo) {	
																setTimeout(function(){		
																	var initailRefNo = null;
																	if (history) {
																		initailRefNo = history.unitRefNo;
																	}
																	
																	loadReferenceNo('TRACTOR', initailRefNo, ElementUtil.query(formPanelHistory, 'unitIdCB'));	
																}, 50);																
															},															
															placeHolder: 'Select',
															listeners: {
																input: {
																	fn: function () {
																		var refNoCB = ElementUtil.query(formPanelHistory, 'unitIdCB');
																		var inputElem = ElementUtil.findInputForCombo(refNoCB);

																		var refType = ElementUtil.query(formPanelHistory, 'referenceType').value;
																		loadReferenceNo(refType, inputElem.value, refNoCB);
																	},
																	buffer: 500
																}
															}															
														},
														{
															tag: 'vaadin-date-time-picker',
															label: 'Start Date',
															name: 'startDate',
															step: 30,
															required: true
														},
														{
															tag: 'vaadin-date-time-picker',
															label: 'End Date',
															name: 'endDate',
															step: 30															
														},
														{
															tag: 'vaadin-text-field',
															name: 'comment',
															label: 'Comment',															
															maxLength: 255
														}
													]
												},		
												{
													tag: 'vaadin-form-layout',
													children: [
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:database', ' Save')
																	],
																	listeners: {
																		click: function () {
																			
																			formPanelHistory.submitForm({
																				preSubmit: function(data) {																				
																					return data;
																				},
																				actualCall: function(data) {			
																					if (history) {
																						data.unitGroupHistoryId = history.unitGroupHistoryId;
																					}
																					return UnitService.getUnitGroupService().saveHistory(record.unitGroupId, data, (history ? true : false));
																				},
																				success: function(data, responseData) {
																					window.DL.MessageUtil.showToast('Success', 'Saved History', {
																						theme: 'success',
																						position: 'top-stretch'
																					});
																					actionRefreshHistory();
																					addEditHistoryWin.close();
																				}
																			});	

																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function () {																		
																			addEditHistoryWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]
										});

										addEditHistoryWin.addToContentElement(formPanelHistory);

										if (history) {
											formPanelHistory.load(history);
										}
									}
								}
							});
						};
						
						var actionDeleteHistory = function(history){
							window.DL.MessageUtil.showConfirm({
								title: 'Confirm Delete',
								message: 'Are you sure you want to delete selected history for unit "' + history.unitRefNo + '"?',
								buttons: [
									{
										text: 'Yes',
										handler: function() {
											var loadMask = historyGrid.showLoading('Removing...');

											UnitService.getUnitGroupService().deleteUnitGroupHistory(history.unitGroupId, history.unitGroupHistoryId)
											.then(function(){
												loadMask.remove();
												window.DL.MessageUtil.showToast('Success', 'Removed history for '+ history.unitRefNo, {									
													theme: 'success'
												});
												actionRefreshHistory();
											}, function(error) {
												loadMask.remove();
											});						
										}
									},
									{
										text: 'No'
									}
								]
							});							
						};
						
						var actionImportHistory = function() {
							var uploadWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Import Group History',
								icon: 'vaadin:upload',
								width: 450,
								height: 235,
								listeners: {
									ready: function () {
										uploadWin.show();

										var uploadHandler = function () {

											var uploadField = ElementUtil.query(uploadFormPanel, 'uploadField');

											if (!uploadField.files || uploadField.files.length < 1) {
												window.DL.MessageUtil.showOkMessage('A group history import file is required.');
											} else {
												uploadField.uploadFiles();
											}

										};

										var uploadFormPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-upload',
													itemid: 'uploadField',
													'no-auto': true,
													'max-files': 1,
													required: true,
													target: '/api/resource/unit-groups/' + record.unitGroupId + '/history/import',
													headers: ImportUtil.getUploadHeader(),
													listeners: {
														'upload-request': function (event) {
														},
														'upload-success': function (event) {
															var responseData = JSON.parse(event.detail.xhr.responseText);
															if (responseData.uploadFile) {
																//error 
																window.DL.MessageUtil.showOkMessage(
																		responseData.uploadFile + '<br>' +
																		responseData.uploadFileType ? responseData.uploadFileType : ''
																		);
															} else {
																window.DL.MessageUtil.showToast('Success', 'Uploaded Successfully.<br>The import will be processed on Task queue.', {
																	theme: 'success',
																	position: 'top-stretch'
																});
																uploadWin.close();
															}
														}
													}
												},
												{
													tag: 'vaadin-form-layout',
													children: [
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:upload', ' Upload')
																	],
																	listeners: {
																		click: function () {
																			if (uploadFormPanel.isValid()) {
																				uploadHandler();
																			}
																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function () {
																			uploadWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]
										});
										uploadWin.addToContentElement(uploadFormPanel);

									}
								}
							});	
							
						};
						
						var actionExportHistory = function() {
							UnitService.getUnitGroupService().exportGroupHistory(record.unitGroupId, historyGrid.currentFilter);
						};
						
					}
				}
			});			
		};
		
		var actionResolveUnits = function(record) {
			var addResolveUnitsWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Units In Group',
				icon: 'vaadin:arrow-circle-right-o',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						addResolveUnitsWin.show();
				
						var resolveToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [
								{
									tag: 'vaadin-date-picker',
									'class': 'spacer-toolbar-item',
									itemid: 'filterStartDate',
									label: 'Filter Start Date',												
									name: 'filterStartDate',
									value: function() {
										return TimeUtil.formatDateForTimeField(TimeUtil.startPreviousMonth());	
									}()
								},
								{
									tag: 'vaadin-date-picker',
									'class': 'spacer-toolbar-item',
									itemid: 'filterEndDate',
									label: 'Filter End Date',												
									name: 'filterEndDate',
									value: function() {
										return TimeUtil.formatDateForTimeField(TimeUtil.endPreviousMonth());	
									}()
								},
								{
									tag: 'vaadin-text-field',
									itemid: 'filterUnitRefNo',
									'class': 'spacer-toolbar-item',
									'keep-open': true,
									label: 'Unit Ref No',
									listeners: {
										input: {
											fn: function() {
												actionRefreshResolutions();
											},
											buffer: 2000
										}
									}
								},
								{
									tag: 'vaadin-button',
									itemid: 'refresh',
									'class': 'spacer-toolbar-item',
									children:[
										ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
									], 
									listeners: {
										click: function() {
											actionRefreshResolutions();
										}
									}
								}								
							]
						});	
						
						var resolveGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'wrap-cell-content row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',							
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true,
								listeners: {
									'direction-changed': function (event) {
										if (event.detail && event.detail.value) {
											resolveGrid.currentSortField = event.target.path;
											resolveGrid.currentSortDirection = event.detail.value.toUpperCase();										
										}
									}
								}
							},
							children: [
								{
									path: 'referenceType',
									header: 'Reference Type',
									width: '7em'
								},
								{
									path: 'unitRefNo',
									header: 'Unit Ref No',
									width: '9em'
								},
								{						
									path: 'startDts',
									header: 'Start Date',
									width: '7em',					
									renderer: function(root, column, rowData) {
										if (rowData.item.startDts) {
											var date = TimeUtil.parseDate(rowData.item.startDts);												
											root.innerHTML = TimeUtil.formatDateStandard(date);						
										}
									}
								},
								{						
									path: 'endDts',
									header: 'End Date',
									width: '7em',					
									renderer: function(root, column, rowData) {
										if (rowData.item.endDts) {
											var date = TimeUtil.parseDate(rowData.item.endDts);												
											root.innerHTML = TimeUtil.formatDateStandard(date);						
										}
									}
								},								
								{
									path: 'adjustedDateByGroupHistory',
									header: 'Adjusted By Group History',
									width: '7em'
								}
							],
							listeners: {
								'active-item-changed': function (event) {
									const item = event.detail.value;
									resolveGrid.selectedItems = item ? [item] : [];									
								}
							}
						});	

						var resolvePagingToolbar = ElementUtil.create({
							tag: 'dl-paging-toolbar',
							slot: 'footer',
							pageSize: 100,
							postinit: function(element) {
								element.grid = resolveGrid;
								element.loader = function(backingGrid, pageNumber, pagingToolbar) {
									var pageRange = pagingToolbar.pullRange();
									var loadMask = resolveGrid.showLoading();

									var loadData = function() {

										var startFilterDts = TimeUtil.startOfDayCompanyTime(ElementUtil.query(resolveToolbar, 'filterStartDate').value);
										var endFilterDts =  TimeUtil.endOfDayCompanyTime(ElementUtil.query(resolveToolbar, 'filterEndDate').value);		

										resolveGrid.currentFilter = {
											offset: pageRange.offset,
											max: pageRange.max,
											sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'unitRefNo',
											sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',																	
											start:  startFilterDts,														
											end: endFilterDts,
											dateField: 'startDts',
											filterField: 'unitRefNo',
											filterValue: ElementUtil.query(resolveToolbar, 'filterUnitRefNo').value
										};

										var successHandler = function(records) {
											loadMask.remove();
											resolveGrid.activeItem = null;		
											
											var allUnitRecords = [];
											records.data.forEach(function(item){
												item.unitInGroupRecords.forEach(function(r){
													allUnitRecords.push(r);
												});
											});
											
											resolveGrid.items = allUnitRecords;

											resolvePagingToolbar.totalRecords = records.totalNumber;
											resolvePagingToolbar.updatePager();						
										};

										UnitService.getUnitGroupService().resolveGroupUnits(record.unitGroupId, resolveGrid.currentFilter).then(function(records){
											successHandler(records);
										});						
									};	

									loadData();

								};
							},
							listeners: {
								ready: function() {					
									resolvePagingToolbar.loadCurrentPage();					
								}
							}

						});						
						
						var resolveFlexLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								resolveToolbar,
								resolveGrid,
								resolvePagingToolbar
							]
						});
						addResolveUnitsWin.addToContentElement(resolveFlexLayout);
							
						var actionRefreshResolutions = function() {
							resolvePagingToolbar.loadPage(1);
						};
						
					}
				}
			});			
		};
		
	}
	
}
customElements.define('dl-unit-group-grid', UnitGroupGrid);